import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { useState, useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { PiWarningCircleBold } from 'react-icons/pi';
// Custom components
import * as React from 'react';
import { IoMdAdd } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import ReactPaginate from 'react-paginate';
import { IoSearchOutline } from 'react-icons/io5';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { addFileCharge, deleteFileCharge, getFileCharge, updateFileCharge } from '../../../redux/actions/Account.action';

export default function Charges() {
  const [show, setShow] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [chargeId, setChargeId] = useState();

  const toggle = () => {
    setShow(!show);
  };
  const updateToggle = () => {
    setUpdateModal(!updateModal);
  };
  const deleteToggle = () => {
    setDeleteModal(!deleteModal);
  };

  const dispatch = useDispatch();
  const getCharge = useSelector((state) => state.account);
  
  const initialValues = {
    fileName: '',
    fileCharge: ''
  }

  const validationSchema = Yup.object().shape({
    fileName: Yup.string().required('File Name is required'),
    fileCharge: Yup.string().required('File Charge is required'),
  });

  const [formData, setFormData] = useState({
    fileName: '',
    fileCharge: ''
  });

  const handleFile = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBranchDetail = (values, { resetForm }) => {
    dispatch(addFileCharge(values)).then(() => {
      toggle();
      resetForm();
    });
  };

  const handleUpadteProblam = (values) => {
    const payload = {
      fileChargeId: chargeId,
      fileName: values.fileName,
      fileCharge: values.fileCharge
    };
    dispatch(updateFileCharge(payload)).then(() => {
      setUpdateModal(false);
    });
  };

  const handleDeleteProblam = () => {
    dispatch(deleteFileCharge(chargeId)).then(() => {
      deleteToggle();
    });
  };

  useEffect(() => {
    dispatch(getFileCharge());
  }, []);

  return (
    <>
      <div className="mt-[100px] d-flex justify-content-end">
        <div className="d-flex items-center gap-3">
          <Button
            onClick={toggle}
            className="!bg-theme-dark fw-bold d-flex align-item-center border-0"
          >
            <IoMdAdd className="mt-1 gap-1" />
            Add Charge
          </Button>
        </div>
      </div>
      <div className="mt-[50px] mb-4">
        <div className='mb-3 flex items-center justify-between mt-5'>
          <h3 className='fw-bold'>Charge List</h3>
        </div>
        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Bill Name</Th>
                <Th>Charge</Th>
                <Th style={{ minWidth: '200px' }} className="text-end">Action</Th>
              </Tr>
            </Thead>
            <Tbody>
              {getCharge?.getFileCharge?.data?.fileCharges?.length > 0 ? (
                getCharge?.getFileCharge?.data?.fileCharges?.map((res) => {
                  return (
                    <Tr key={res._id}>
                      <Td>{res.fileName}</Td>
                      <Td>{res.fileCharge}</Td>
                      <Td>
                        <div className="d-flex gap-3 justify-end">
                          <FaEdit
                            onClick={() => {
                              updateToggle();
                              setFormData(res);
                              setChargeId(res._id);
                            }}
                            className="cursor-pointer border-green-color fs-5 text-success"
                            title="update"
                          />
                          <MdDelete
                            onClick={() => {
                              deleteToggle();
                              setChargeId(res._id);
                            }}
                            className="cursor-pointer border-green-color fs-5 text-danger"
                            title="delete"
                          />
                        </div>
                      </Td>
                    </Tr>
                  );
                })
              ) : (
                <>
                  <Tr>
                    <Td colSpan={3} textAlign='center'>Bill Not Found</Td>
                  </Tr>
                </>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      {/* add problem */}

      <Modal show={show} onHide={toggle}>
        <Modal.Header closeButton>
          <Modal.Title>Add Charge</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleBranchDetail}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>File Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="fileName"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('fileName', e.target.value)}
                        value={values.fileName}
                        placeholder="Enter File Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="fileName"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Charge</Form.Label>
                      <Form.Control
                        type="text"
                        name="fileCharge"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('fileCharge', e.target.value)}
                        value={values.fileCharge}
                        placeholder="Enter File Charge"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="fileCharge"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={toggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="!bg-theme-dark border-0 px-4"
                // onClick={}
                >
                  Add
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* update problem */}

      <Modal show={updateModal} onHide={updateToggle}>
        <Modal.Header closeButton>
          <Modal.Title>Update Branch</Modal.Title>
        </Modal.Header>
        <Formik
          enableReinitialize={true}
          initialValues={formData}
          validationSchema={validationSchema}
          onSubmit={handleUpadteProblam}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>File Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="fileName"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('fileName', e.target.value)}
                        value={values.fileName}
                        placeholder="Enter Branch Name"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="fileName"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Chage</Form.Label>
                      <Form.Control
                        type="text"
                        name="fileCharge"
                        as={Form.Control}
                        onChange={(e) =>
                          setFieldValue('fileCharge', e.target.value)}
                        value={values.fileCharge}
                        placeholder="Enter Location"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="fileCharge"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={updateToggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="!bg-theme-dark border-0 px-4"
                // onClick={handleUpadteProblam}
                >
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* delete problem */}

      <Modal show={deleteModal} onHide={deleteToggle}>
        <Modal.Body className='p-5'>
          <div>
            <PiWarningCircleBold className='text-7xl w-100 text-danger' />
          </div>
          <div className='text-center mt-4'>
            <h3>Are You Sure ?</h3>
            <p className='text-md'>Do you really want to delete these records?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={deleteToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="bg-danger border-0 px-4"
            onClick={handleDeleteProblam}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
